function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1534",
  "data-name": "Group 1534",
  transform: "translate(-1502 -213)"
}, /*#__PURE__*/React.createElement("text", {
  id: "F-Gas",
  transform: "translate(1502 226)",
  fill: "#333",
  fontSize: 12,
  fontFamily: "Poppins-Bold, Poppins",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "F-Gas")), /*#__PURE__*/React.createElement("text", {
  id: "Certified",
  transform: "translate(1502 233)",
  fill: "#333",
  fontSize: 7,
  fontFamily: "Poppins-Regular, Poppins"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "Certified")));

var SvgHaveCert = function SvgHaveCert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 22,
    viewBox: "0 0 38 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHaveCert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/haveCert.3f137ffe.svg";
export { ForwardRef as ReactComponent };